export const isFromFoundApp = () => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
  return userAgent.toLowerCase().includes('found')
}

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
